import React from "react";
import { API_ROOT } from "../../../services/api";
import CartIcon from "../../Layout/Icons/CartIcon";
import "./Cart.css";

class Cart extends React.Component {
  render() {
    return (
      <div className="customizer-cart">
        <div className="cart__icon">
          <a href={`${API_ROOT}cart`}>
            <CartIcon />
          </a>
        </div>
      </div>
    );
  }
}

export default Cart;
